import React, { useEffect, useState } from "react";
import "./../profile.css";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { profileAction } from "../../../redux/action";
import { getUser } from "../../../constant/utils";
import Loader from "react-loader-spinner";

const ActivityLogs = () => {
  const dispatch = useDispatch();
  const USER: any = getUser();
  const [userActivityLog, setUserActivityLog] = useState<any[]>([]);
  const userActivityLogData = useSelector((state: any) => state?.profile?.userActivityLog || []);
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));
  useEffect(() => {
    dispatch(profileAction.userActivityLogAction({}));
  }, []);
  useEffect(() => {
    setUserActivityLog(userActivityLogData?.slice(0, 10) || []);
  }, [userActivityLogData]);

  return (
    <div className="tc_box">
      <div className="heading_box">
        <div className="row justify-content-between">
          <span className="col">Activity Logs</span>
        </div>
      </div>
      {commonLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#fff" height={100} width={100} />
        </div>
      ) : (
        <div className="payment_history_Table">
          <table>
            <thead>
              <tr>
                <th style={{ width: "60px" }}>S. No.</th>
                <th>Action</th>
                <th>Created At</th>
              </tr>
            </thead>
            <tbody>
              {userActivityLog && userActivityLog?.length > 0 ? (
                userActivityLog?.map((logs: any, idx: any) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{logs?.action}</td>
                    <td>{logs?.created_at ? moment(logs?.created_at)?.format("DD MMM, YYYY hh:mm A") : ""}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={3}><strong>No record found</strong></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {userActivityLog?.length > 10 && (
        <div className="text-center">
          <button
            type="submit"
            className="book--hexagon active sm_form"
            onClick={() => setUserActivityLog(userActivityLogData)}
          >
            <span className="text-capitalize">
              View All
              <i className="fa fa-long-arrow-right ml-20" aria-hidden="true"></i>
            </span>
          </button>
        </div>
      )}
    </div>
  );
};

export default ActivityLogs;
